import {PlayersStatisticsTableColumnGroupDomainModel} from "./players-statistics.table.column-group.domain-model";
import {BaseViewModel} from "../../../../../../infrastructure/models/base-view-model";

export class PlayersStatisticsTableColumnGroupViewModel extends BaseViewModel {
  domainModel: PlayersStatisticsTableColumnGroupDomainModel;

  constructor(domainModel: PlayersStatisticsTableColumnGroupDomainModel, columns) {
    super(domainModel);

    this.columns = columns;
  }

  get order(): Number {
    return this.domainModel.order;
  }

  get name(): String {
    return this.domainModel.name;
  }


}
